import React, { ReactNode } from "react";

import TranslationsProvider from "./translations/TranslationsProvider";
import ChatwootProvider from "./chatwoot/ChatwootProvider";

interface Props {
  children: ReactNode;
}

function Providers(props: Props) {
  const { children } = props;

  return (
    <ChatwootProvider>
      <TranslationsProvider>{children}</TranslationsProvider>
    </ChatwootProvider>
  );
}

export default Providers;
